export const POLICY_LINKS = Object.freeze([
  ["Policy Centre", "/policies"],
  ["Privacy", "/privacy"],
  ["Data Rights", "/data-rights"],
  ["Cookie & Storage", "/cookies"],
  ["Terms of Use", "/terms"],
  ["Terms of Sale", "/terms-of-sale"],
  ["Shipping", "/shipping"],
  ["Parcel Issues", "/parcel-issues"],
  ["Returns", "/returns"],
  ["Cancellations", "/cancellations"],
  ["International Orders", "/international-orders"],
  ["Payments", "/payments"],
  ["Product Details", "/product-details-policy"],
  ["Product Care", "/product-care"],
  ["Reviews & Content", "/reviews-content"],
  ["Intellectual Property", "/intellectual-property"],
  ["Accessibility", "/accessibility"],
  ["Packaging", "/packaging"],
  ["Complaints", "/complaints"],
  ["Contact Policy", "/contact-policy"],
  ["FAQ", "/faq"],
]);
